import { postRequest } from '@bo-apis/axios';

const getOpenApiApprovalKeyList = (pageable) =>
  postRequest({
    url: '/api/v1/po/system/open-api-approval-key/get-open-api-approval-key-list',
    params: { ...pageable },
  });

const getOpenApiCertificationKeyList = (pageable) =>
  postRequest({
    url: '/api/v1/po/system/open-api-certification-key/get-open-api-certification-key-list',
    params: { ...pageable },
  });

const createOpenApiApprovalKey = () =>
  postRequest({
    url: '/api/v1/po/system/open-api-approval-key',
  });

const invalidateOpenApiCertificationKey = () =>
  postRequest({
    url: '/api/v1/po/system/open-api-certification-key/invalidate-open-api-certification-key',
  });

const poOpenApi = {
  getOpenApiApprovalKeyList,
  getOpenApiCertificationKeyList,
  createOpenApiApprovalKey,
  invalidateOpenApiCertificationKey,
};

export default poOpenApi;
